export default __webpack_public_path__ + "static/media/05AW3APR66.80e5a105.jpg";